import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataService } from "../../../../../src/app/shared/services/data.service";
import {
  QuizQuestion,
  ResponseData,
  TeamDetails,
  UnAnsweredList,
} from "../../../../../src/app/shared/services/teacher.interface";
import { interval, merge, of, Subject, timer } from "rxjs";
import { takeUntil, finalize, startWith, switchMap } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationComponent } from "../../../../../src/app/shared/dialogs/confirmation/confirmation.component";
import { LanguageService } from "../../../../../src/app/shared/services/language/language.service";
import { ImageModalComponent } from "../../../../../src/app/shared/dialogs/image-modal/image-modal.component";
import { ResponseType } from "../../question/question.component";

@Component({
  selector: "app-quiz",
  templateUrl: "./quiz.component.html",
  styleUrls: ["./quiz.component.scss"],
})
export class QuizComponent implements OnInit {
  teamId = sessionStorage.getItem("GCGroup");
  group = sessionStorage.getItem("group");
  isGamefinished: boolean = false;
  unAnsweredListDetails: UnAnsweredList;
  unAnsweredList = [];
  questionDetails: QuizQuestion;
  showAnim = false;
  isCorrect = false;
  currentStatus: number;
  // canEndQuiz = true;
  intervalOne: any;

  selectedOption: string | null = null; // User's selected option
  correctOption: string = ""; // ID of the correct option
  showTempStyle: boolean = false; // Temporary style for 2 seconds
  hasAnswered: boolean = false;

  timeRemaining: string = "10:00"; // Initial time to display
  private durationInSeconds: number = 605; // 10:05 minutes in seconds
  private stop$ = new Subject<void>(); // Used to stop timers and polling
  isTimeUp: boolean = false; // Indicates if the time is up
  selectedLang: any = localStorage.getItem("userLang") == "en" ? "en_us" : "nl";

  constructor(
    private dataService: DataService,
    private dialog: MatDialog,
    private router: Router,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    history.pushState(null, "", window.location.href);
    this.getServerTime();
    this.languageService.translateLanguge.subscribe((value) => {
      this.selectedLang = value == "en" ? "en_us" : "nl";
    });
    this.checkTeamStatus();
  }

  @HostListener("window:popstate", ["$event"])
  onPopState(event: any) {
    sessionStorage.removeItem("GCTeamCode");
    sessionStorage.removeItem("GCGroup");
    sessionStorage.removeItem("GCTeamGroupId");
    sessionStorage.removeItem("group");
  }

  getServerTime() {
    merge(
      of(0), // Emit immediately
      timer(4000) // Emit after 4 seconds
    )
      .pipe(
        switchMap(() => this.dataService.getServerTime(this.group)), // Call API
        takeUntil(this.stop$) // Stop if component is destroyed
      )
      .subscribe({
        next: (res: ResponseType<{ remaining_time: number }>) => {
          this.durationInSeconds = res.data.remaining_time;
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  // getServerTime(){
  //   interval(1000)
  //     .pipe(
  //       startWith(0), // Call API immediately on start
  //       takeUntil(this.stop$), // Stop polling when the component is destroyed
  //       switchMap(() => this.dataService.getServerTime(this.group))
  //     )
  //     .subscribe({
  //       next: (res:ResponseType<{remaining_time:number}>) => {
  //         this.durationInSeconds = res.data.remaining_time
  //       },
  //       error: (err) => {
  //         console.error(err);
  //       },
  //     });
  // }

  checkTeamStatus() {
    this.dataService.getWaitingTeamStatus(this.teamId).subscribe({
      next: (res: ResponseData<TeamDetails>) => {
        if (res.data?.status == 102) {
          this.currentStatus = res.data.status;
          // sessionStorage.setItem('s_end_time',res.data.end_time.toString())
          this.initializeTimer();
          this.getUnAnsweredList();
        } else if (res.data?.status == 103) {
          this.currentStatus = res.data.status;
          this.unAnsweredListDetails = null;
          this.unAnsweredList = [];
          this.questionDetails = null;
          this.router.navigateByUrl("/quiz-finished");
        } else {
          this.currentStatus = res.data.status;
          this.unAnsweredListDetails = null;
          this.unAnsweredList = [];
          this.questionDetails = null;
          this.router.navigateByUrl("/quiz-finished");
        }
      },
      error: (err) => {
        this.router.navigateByUrl("/loby");
      },
    });
  }

  getTranslation(source: any, property: any) {
    return source ? source[`${property}_${this.selectedLang}`] : "";
  }

  selectOption(optionId: string): void {
    this.questionDetails.image = null;
    this.selectedOption = optionId;
    this.showTempStyle = true;
    this.hasAnswered = true;
    // this.canEndQuiz = false;
    setTimeout(() => {
      this.showTempStyle = false;
      this.correctOption = this.questionDetails.correct_option;
      if (this.selectedOption == this.questionDetails.correct_option) {
        this.showAnim = true;
        this.isCorrect = true;
        this.submitAnswer(this.selectedOption, true);
      } else {
        this.showAnim = true;
        this.isCorrect = false;
        this.submitAnswer(this.selectedOption, false);
      }
    }, 2000); // 2-second delay before showing correct/incorrect styles
  }

  getIcon(option: any): string {
    if (option.id === this.correctOption) {
      return "assets/icons/correct.svg"; // Icon for correct answer
    } else if (
      option.id === this.selectedOption &&
      option.id !== this.correctOption
    ) {
      return "assets/icons/wrong.svg"; // Icon for wrong answer
    }
    return ""; // No icon for unselected options
  }

  getUnAnsweredList() {
    this.dataService.getQuizQestionList(this.teamId).subscribe({
      next: (res: ResponseData<UnAnsweredList>) => {
        if (res.data.count != 0) {
          this.unAnsweredListDetails = res.data;
          this.currentStatus = res.data?.status;
          // sessionStorage.setItem('s_end_time',res.data.end_time.toString())
          this.selectedOption = "";
          this.showTempStyle = false;
          this.hasAnswered = false;
          this.showAnim = false;
          this.isCorrect = false;
          this.unAnsweredList = res.data.results;
          // this.canEndQuiz = true;
          this.getQuestionDetails(this.unAnsweredList[0]?.id);
        } else {
          // no unanswered questons
          this.unAnsweredListDetails = res.data?.completed_time
            ? null
            : res.data;
          this.currentStatus = res.data?.status;
          this.completeQuiz();
          this.intervalOne = setTimeout(() => {
            this.router.navigateByUrl("/quiz-finished");
          }, 2000);
        }
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  completeQuiz() {
    let body = {
      is_completed: "True",
      // completed_time: Math.floor(Date.now() / 1000)
    };
    this.dataService.studentQuizCompleted(this.teamId, body).subscribe({
      next: (res) => {},
      error: (err) => {
        console.error(err);
      },
    });
  }

  getQuestionDetails(questionId: string) {
    this.dataService.getQuizQuestion(questionId, this.teamId).subscribe({
      next: (res: ResponseData<QuizQuestion>) => {
        this.questionDetails = res.data;
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  submitAnswer(selectedOpt: string, isCorrect: boolean) {
    let body = {
      selected_option: selectedOpt,
      is_right: isCorrect == true ? "True" : "False",
    };
    this.dataService
      .patchQuizAnswer(this.unAnsweredList[0]?.id, this.teamId, body)
      .subscribe({
        next: (value) => {
          setTimeout(() => {
            this.getUnAnsweredList();
          }, 4000);
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  initializeTimer() {
    // const endTime = Number(sessionStorage.getItem('s_end_time'));
    // const currentTimeUnix = Math.floor(Date.now() / 1000); // Get current Unix time (seconds since epoch)
    // this.durationInSeconds = Math.max(0, endTime - currentTimeUnix); // Calculate remaining time, ensuring it doesn't go below 0

    timer(0, 1000) // Emit immediately and every second
      .pipe(
        startWith(0),
        takeUntil(this.stop$),
        finalize(() => {
          this.isTimeUp = true;
        })
      )
      .subscribe(() => {
        if (this.durationInSeconds > 600) {
          this.durationInSeconds--;
          this.timeRemaining = this.formatTime(600);
        } else if (this.durationInSeconds > 0) {
          this.durationInSeconds--;
          this.timeRemaining = this.formatTime(this.durationInSeconds);
        } else {
          this.stopPolling();
        }
      });
  }

  // Format time in mm:ss
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${this.padZero(minutes)}:${this.padZero(remainingSeconds)}`;
  }

  // Helper to pad numbers with zero
  padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  // Stop polling and timers
  stopPolling() {
    this.stop$.next();
    this.completeQuiz();
    setTimeout(() => {
      this.router.navigateByUrl("/quiz-finished");
    }, 2000);
  }

  cancelQuiz() {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      disableClose: true,
      data: { game: true },
    });
    dialogRef.afterClosed().subscribe((data: boolean) => {
      if (data) {
        this.unAnsweredListDetails = null;
        this.unAnsweredList = [];
        this.questionDetails = null;
        clearInterval(this.intervalOne);
        sessionStorage.removeItem("GCTeamCode");
        // sessionStorage.removeItem("GCGroup");
        sessionStorage.removeItem("group");
        let id = sessionStorage.getItem("GCTeamGroupId");
        this.router.navigateByUrl(`/loby?id=${id}`);
      }
    });
  }

  showImage() {
    let imageLink =
      this.selectedLang == "en_us"
        ? this.questionDetails?.image_en_us
        : this.questionDetails?.image_nl;
    this.dialog.open(ImageModalComponent, {
      disableClose: true,
      data: { image: imageLink },
    });
  }

  ngOnDestroy(): void {
    // if(this.currentStatus == 102 && this.stop$){
    //   sessionStorage.removeItem('GCTeamCode');
    //   sessionStorage.removeItem('GCGroup');
    // }
    // sessionStorage.removeItem('s_end_time')
    clearInterval(this.intervalOne);
    this.dialog.closeAll();
    this.stop$.next();
    this.stop$.complete();
  }
}
